import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import translationEN from "./assets/i18n/en.json";
import translationIT from "./assets/i18n/it.json";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const resources = {
  en: {
    translation: translationEN,
  },
  it: {
    translation: translationIT,
  },
};

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ["it", "en"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
